<template>
  <div :class="[$style.config, $style.wrap]">
    <div :class="$style.type">
      <IconPlayNegative :class="$style.icon" />
      <span :class="$style.label">
        {{ data?.fields?.mediaType?.fields?.label }}
      </span>
    </div>

    <VideoContent :data="data" />

    <div :class="$style.frameInner">
      <header v-if="data?.fields?.title">
        <BaseHeading as="h3" size="h5" :class="$style.title">
          {{ data?.fields?.title }}
        </BaseHeading>
      </header>
      <time
        v-if="data?.fields?.date"
        :datetime="data?.fields?.dateTime"
        :class="$style.date"
      >
        {{ data?.fields?.date }}
      </time>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeVideoContentWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeVideoContentWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.config {
  --icon-color: #99337b;

  --title-color: var(--white);

  --frame-background: rgba(0, 0, 0, 0.75);

  @include breakpoint-variables(
    '--frame-padding',
    (
      base: 0.5em 1.25em,
      sm: 1em 2em,
    )
  );

  --playlist-date-color: #667080;
}

.wrap {
  will-change: backdrop-filter;
  backface-visibility: hidden; // remove flicker
  background: var(--frame-background);
  backdrop-filter: blur(4px);
  border-radius: 0.75em;
  padding: var(--frame-padding);
}

.type {
  display: flex;
  align-items: center;
  padding: 1em 0;
}

.icon {
  width: 1.25em;
  height: 1.25em;
  color: var(--icon-color);
}

.label {
  display: inline-block;

  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;

  margin: 0 0.5em;
  color: var(
    --label-color,
    #fff
  ); // this var is set in contentful, don't change!
}

.frameInner {
  padding: 1em 0;
}

.title {
  color: var(--title-color);
  text-transform: none;
  margin: 0.5em 0;
}

.date {
  color: var(--playlist-date-color);
  font-weight: bold;
  font-size: 12px;
  display: none;

  @include media('xs') {
    display: block;
  }
}
</style>
